import {Injectable} from '@angular/core';
import {FnApplicationHelper} from './fn-application.helper';
import {FnExceptionService} from '../exception/fn-exception.service';
import {FNExceptionJson} from '../exception/fn-exception-json';


@Injectable()
export class FnApplication {

  constructor(private fnAppHelper: FnApplicationHelper, private fnExp: FnExceptionService) {
    this.fnAppHelper.setApplication(this);
    this.fnExp.setFnApplicationHelper(this.fnAppHelper);
  }

  sendExceptionToServer(exception: FNExceptionJson) {
  }
}
